import { editorOrAbovePolicy } from "./common";

/** User Analytics リソースのポリシー定義です。 */
export const UA_POLICIES = {
  /** プロジェクトの作成・並び替え可否を判定します。 */
  "ua-project:edit": editorOrAbovePolicy,
  /** ビュー（キーイベント・Session Explorer 等）の操作可否を判定します。 */
  "ua-view:edit": editorOrAbovePolicy,
  /** User Analytics の BigQuery 設定操作の可否を判定します。 */
  "ua-bigquery:edit": editorOrAbovePolicy,
} as const;
